import createIcon from '../../createIcon';

/**
 * @component @name Repeat
 * @description Google Material SVG icon component, renders SVG Element with children.
 *
 * @preview ![img](data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMjQiIGhlaWdodD0iMjQiIHZpZXdCb3g9IjAgMCAyNCAyNCIgZmlsbD0ibm9uZSIgeG1sbnM9Imh0dHA6Ly93d3cudzMub3JnLzIwMDAvc3ZnIj48cGF0aCBkPSJNNyA3SDE3VjEwTDIxIDZMMTcgMlY1SDVWMTFIN1Y3Wk0xNyAxN0g3VjE0TDMgMThMNyAyMlYxOUgxOVYxM0gxN1YxN1oiIGZpbGw9ImJsYWNrIi8+Cjwvc3ZnPgo=)
 *
 * @param {Object} props - Google Material icons props and any valid SVG attribute
 * @returns {JSX.Element} JSX Element
 *
 */
const Repeat = createIcon('Repeat', [
  [
    'path',
    { d: 'M7 7H17V10L21 6L17 2V5H5V11H7V7ZM17 17H7V14L3 18L7 22V19H19V13H17V17Z', key: '1g60ih' },
  ],
]);

export default Repeat;
